import { TutorialStep } from "..";

export const TrainOptionSettingSteps: TutorialStep[] = [
  {
    target: "#train-option-setting",
    content: "자동 라벨링 활성화 시 특정조건에 맞게 라벨링을 진행합니다.",
    spotlightClicks: false,
    hideFooter: false,
    placement: "bottom",
    disableOverlayClose: true,
  },
  {
    // 안내만 한다. 기본 모델 그대로 두고 넘어가도 프로젝트 생성에 문제 없음
    target: "#select-model",
    content: "학습/검증에 쓰일 모델을 선택할 수 있습니다.\n여기서는 기본값 그대로 진행합니다.",
    spotlightClicks: false,
    hideFooter: false,
    placement: "bottom",
    disableOverlayClose: true,
  },
  {
    target: "#finish-btn",
    content: "버튼을 클릭하여 프로젝트 생성을 완료합니다.",
    spotlightClicks: true,
    hideFooter: true,
    placement: "bottom",
    disableOverlayClose: true,
  },
];
